// extracted by mini-css-extract-plugin
module.exports = {"video":"index_video__YARcW","title":"index_title__xtZ2T","description":"index_description__tfvXG"};